export enum Duration {
  SESSION = 'cookieInfoPage.table.duration.session',
  HOURS = 'cookieInfoPage.table.duration.hours',
  DAYS = 'cookieInfoPage.table.duration.days',
  MONTHS = 'cookieInfoPage.table.duration.months',
  YEARS = 'cookieInfoPage.table.duration.years',
}

export enum CookieConsentType {
  REQUIRED = 'TABLE_REQUIRED',
  FUNCTIONAL = 'TABLE_FUNCTIONAL',
  PERFORMANCE = 'TABLE_PERFORMANCE',
  MARKETING = 'TABLE_MARKETING',
}

export interface ICookie {
  readonly name: string;
  readonly service: string;
  readonly duration: readonly [duration: Duration, count?: number];
}

export interface ICookieSection {
  readonly type: CookieConsentType;
  readonly cookies: ICookie[];
}